"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _static = require("@otpusk/json-api/dist/static");
var _Checkbox = _interopRequireDefault(require("../../../../../../../ui/Checkbox"));
var _price = require("../../../../../../../../helpers/price");
var _selectors = require("../../../../store/selectors");
var _actions = require("../../../../store/actions");
var _styles = _interopRequireDefault(require("./styles.scss"));
var _service = _interopRequireDefault(require("./img/service.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ServiceItem = function ServiceItem(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    price = _ref.price,
    detailsLink = _ref.detailsLink;
  var selectedServices = (0, _reactRedux.useSelector)(_selectors.getActiveIntegrationServices);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _service.default
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.info
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, /*#__PURE__*/_react.default.createElement("span", null, name), detailsLink && /*#__PURE__*/_react.default.createElement("a", {
    href: detailsLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, t('INTEGRATION_SERVICE_DETAILS_LINK'))), description && /*#__PURE__*/_react.default.createElement("p", null, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.price
  }, /*#__PURE__*/_react.default.createElement("span", null, (0, _price.preparePriceForRender)(price, _static.CURRENCIES_MAP.uah.symbol)), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: Boolean(selectedServices[id]),
    onChange: function onChange(checked) {
      dispatch(checked ? (0, _actions.setActiveIntegrationService)(id) : (0, _actions.detachActiveIntegrationService)(id));
    }
  })));
};
ServiceItem.propTypes = {
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  price: _propTypes.default.number.isRequired,
  description: _propTypes.default.string,
  detailsLink: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(ServiceItem);